<template>
  <div>
    <div class="row">
      <div class="col-12">
        <form id="form-topic" v-on:submit.prevent="saveSubtopic()">
          <div class="form-group">
            <ejs-textbox name="topic"
                         id="topic"
                         v-model="dataForm.topic"
                         :placeholder="$t('topicsSubTopics.placeholder.topic_name')"
                         data-msg-containerid="formTopicError"></ejs-textbox>
            <div id="formTopicError"></div>
          </div>

          <ejs-button
              v-if="!is_processing && data.type === 'create'"
              type='submit'
              cssClass="e-primary"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.buttons.save') }}
          </ejs-button>

          <ejs-button
              v-if="!is_processing && data.type === 'update'"
              type='submit'
              cssClass="btn btn-warning"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.buttons.update') }}
          </ejs-button>

          <ejs-button
              v-if="is_processing"
              type='submit'
              cssClass="e-primary"
              :disabled="is_processing">
            {{ $t('topicsSubTopics.messages.processing') }}
          </ejs-button>
        </form>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'form-topic',
  props: {
    data: {
      required: true,
    }
  },
  mounted() {
    this.formObject = new FormValidator('#form-topic', this.optionsForms);
    if (this.data.type === 'update') {
      this.dataForm.topic = this.data.topic;
      this.dataForm.topic_id = this.data.topic_id;
    }
  },
  data() {
    return {
      allowFiltering: true,
      ignoreAccent: true,
      dataForm: {
        topic: '',
        topic_id: undefined
      },
      formObject: '',
      optionsForms: {
        rules: {
          'topic': {
            required: [true, this.$t('topicsSubTopics.validations.topic')],
          }
        },
      }
    }
  },
  watch: {
    is_processing(value) {
      if (!value) {
        Vue.prototype.$eventHub.$emit("closeSidebarClick");
      }
    }
  },
  computed: {
    is_processing() {
      return this.$store.getters['moduleTopicsSubtopics/isProcessing'];
    }
  },
  methods: {
    saveSubtopic() {

      let formStatus = this.formObject.validate();
      if(!formStatus){
        return;
      }

      if (this.data.type === 'update') {
        this.$store.dispatch('moduleTopicsSubtopics/updateTopicInServer', {
          topic: this.dataForm.topic,
          topic_id: this.dataForm.topic_id,
        });
        return;
      }

      this.$store.dispatch('moduleTopicsSubtopics/saveTopicInServer', {
        topic: this.dataForm.topic,
      });
    }
  }
}
</script>